import {format} from 'date-fns'

import localize from 'utils/localizer'

export function formatDate(value, _formatDate) {
  const formatMessage = value ? format(new Date(value), _formatDate) : null
  return formatMessage
}

export function formatDateDDMMYYYYHHMMSS(value) {
  const formatMessage = value ? format(new Date(value), 'yyyy-MM-dd HH:mm:ss') : null
  return formatMessage
}

export function formatDateDDMMYYYY(value) {
  const formatMessage = value ? format(new Date(value), 'dd/MM/yyyy') : null
  return formatMessage
}

export function formatDateYYYYMMDD(value) {
  const formatMessage = value ? format(new Date(value), 'yyyy-MM-dd') : ''
  return formatMessage
}
export function formatDateToISOString(value) {
  return value ? new Date(value).toISOString() : null
}

export function formatDateToTimeStamp(value) {
  return value ? new Date(value).valueOf() : null
}

export function formatDateRange(valueFrom, valueTo, locale) {
  return valueFrom && valueTo
    ? `${formatDate(valueFrom, locale)} - ${formatDate(valueTo, locale)}`
    : ''
}

export const getLocaleDays = days => {
  if (typeof days === 'object') {
    return (Object.keys(days) || []).map(dayKey => ({
      locale: localize(days[dayKey]),
      key: days[dayKey],
    }))
  }

  return []
}

export const normalizeWeekDaysInString = _weekDays => {
  if (_weekDays.length) {
    return _weekDays.join(',')
  }

  return ''
}

export const validateIfIsValidityDate = (startDate, endDate) => {
  const today = new Date().valueOf()
  return (
    today > formatDateToTimeStamp(startDate) && today < formatDateToTimeStamp(endDate)
  )
}

export const localizeDaysFromString = _weekDays => {
  if (_weekDays) {
    const days = ('' + _weekDays).split(',') || []
    const normalizeDays = days
      .map(day => {
        return localize(day.trim())
      })
      .join(', ')

    return normalizeDays
  }

  return ''
}
